(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bl-symbol-explorer"] && !Shopify.designMode) return;
  try {
    
  /* [BL] Symbol explorer: switches the shown Symbol (rail chips, arrow keys, group siblings), swaps
     the photo and the jewellery circle, and "Select <month>" picks that option in the page's variant
     picker. */
  (function () {
    if (customElements.get('bl-symbol-explorer')) return;

    class BlSymbolExplorer extends HTMLElement {
      connectedCallback() {
        this.panels = Array.from(this.querySelectorAll('.bl-sx__panel'));
        this.media = Array.from(this.querySelectorAll('.bl-sx__media-item'));
        this.chips = Array.from(this.querySelectorAll('.bl-sx__chip'));
        this.rail = this.querySelector('.bl-sx__rail');
        this.track = this.querySelector('.bl-sx__media');
        this.addEventListener('click', this.onClick);
        this.rail?.addEventListener('keydown', this.onKeydown);
        this.track?.addEventListener('scroll', this.onTrackScroll, { passive: true });
        this.track?.addEventListener('mousedown', this.onMouseDown);
        const linked = this.linkedIndex();
        this.activate(linked ?? (Number(this.dataset.start) || 0), false);
        // Arriving on a flower (?flower=) counts as a pick; the default opening one doesn't.
        if (linked !== null) this.followPick();
        // Neighbours' photos load once the explorer is close, so swiping to them is instant.
        this.nearObserver = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting) return;
          this.near = true;
          this.reveal(this.index);
          this.nearObserver.disconnect();
        }, { rootMargin: '400px 0px' });
        this.nearObserver.observe(this);
      }

      // Images held back by the Liquid (data-bl-src / data-bl-srcset) get their real URLs: the shown
      // Symbol's, plus the ones either side once the explorer is near view.
      reveal(index) {
        const indexes = this.near ? [index - 1, index, index + 1] : [index];
        for (const i of indexes) {
          for (const img of this.querySelectorAll(`[data-index="${i}"] [data-bl-src], [data-index="${i}"] [data-bl-srcset]`)) {
            if (img.dataset.blSrcset) img.setAttribute('srcset', img.dataset.blSrcset);
            if (img.dataset.blSrc) img.setAttribute('src', img.dataset.blSrc);
            img.removeAttribute('data-bl-srcset');
            img.removeAttribute('data-bl-src');
          }
        }
      }

      // "Page buttons follow the pick": the page's other buttons (a.button, outside this explorer) that link to
      // any of the panels' pieces are pointed at the picked one, so the hero / floating / final CTA land on it.
      followPick() {
        if (!this.hasAttribute('data-follow-pick')) return;
        const pick = this.panels[this.index]?.querySelector('.bl-sx__cta--shop');
        if (!pick) return;
        const pathOf = (href) => new URL(href, window.location.href).pathname;
        this.piecePaths ??= new Set(
          Array.from(this.querySelectorAll('.bl-sx__cta--shop'), (link) => pathOf(link.href))
        );
        for (const link of document.querySelectorAll('a.button[href]')) {
          if (this.contains(link) || !this.piecePaths.has(pathOf(link.href))) continue;
          link.href = pick.href;
        }
      }

      // ?flower=<name or Symbol handle> (e.g. from an ad for that flower) opens on that Symbol.
      linkedIndex() {
        const wanted = new URLSearchParams(window.location.search).get('flower')?.trim().toLowerCase();
        if (!wanted) return null;
        const panel = this.panels.find((p) => p.dataset.handle === wanted || p.dataset.name === wanted);
        return panel ? Number(panel.dataset.index) : null;
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.rail?.removeEventListener('keydown', this.onKeydown);
        this.track?.removeEventListener('scroll', this.onTrackScroll);
        this.track?.removeEventListener('mousedown', this.onMouseDown);
        this.nearObserver?.disconnect();
        this.dragController?.abort();
      }

      // Mouse: drag the photo sideways to the next Symbol, like the product gallery (touch swipes natively).
      onMouseDown = (event) => {
        const track = this.track;
        if (!track || event.button !== 0 || this.panels.length < 2) return;
        if (event.target instanceof Element && event.target.closest('[data-sx-swap]')) return;
        event.preventDefault();

        const startX = event.clientX;
        const startLeft = track.scrollLeft;
        let lastX = startX;
        let lastTime = performance.now();
        let velocity = 0;
        let moved = false;
        const swallowClick = (e) => {
          e.preventDefault();
          e.stopPropagation();
        };

        this.dragController?.abort();
        const controller = (this.dragController = new AbortController());
        const { signal } = controller;

        document.addEventListener(
          'mousemove',
          (e) => {
            const dx = e.clientX - startX;
            if (!moved && Math.abs(dx) < 4) return;
            if (!moved) {
              moved = true;
              track.toggleAttribute('data-dragging', true);
              // A drag isn't a click (the jewellery circle sits on the photo).
              document.addEventListener('click', swallowClick, { capture: true, once: true });
            }
            const now = performance.now();
            velocity = (e.clientX - lastX) / Math.max(now - lastTime, 1);
            lastX = e.clientX;
            lastTime = now;
            track.scrollLeft = startLeft - dx;
          },
          { signal }
        );

        document.addEventListener(
          'mouseup',
          () => {
            controller.abort();
            if (!moved) return;
            setTimeout(() => document.removeEventListener('click', swallowClick, { capture: true }), 0);
            const width = track.clientWidth || 1;
            const from = Math.round(startLeft / width);
            let index = Math.round(track.scrollLeft / width);
            // A quick flick moves one on even when it didn't reach halfway.
            if (index === from && Math.abs(velocity) > 0.3) index = from + (velocity < 0 ? 1 : -1);
            index = Math.max(0, Math.min(this.panels.length - 1, index));
            track.removeAttribute('data-dragging');
            this.activate(index, false);
          },
          { signal }
        );
      };

      // Swiping the photo: once it settles, show that slide's Symbol (the photo is already there).
      onTrackScroll = () => {
        clearTimeout(this.trackTimer);
        this.trackTimer = setTimeout(() => {
          const track = this.track;
          if (!track || !track.clientWidth) return;
          const index = Math.round(track.scrollLeft / track.clientWidth);
          if (index !== this.index) this.activate(index, false, true);
        }, 120);
      };

      activate(index, fromKeyboard, fromSwipe) {
        const panel = this.panels[index];
        if (!panel) return;
        const first = this.index === undefined;
        this.index = index;
        this.reveal(index);
        if (!first) this.followPick();
        this.panels.forEach((p, i) => {
          p.toggleAttribute('data-active', i === index);
          p.setAttribute('aria-hidden', String(i !== index));
        });
        this.media.forEach((m, i) => {
          m.toggleAttribute('data-active', i === index);
          m.toggleAttribute('inert', i !== index);
        });

        // Slide the photo there (sideways only, never the page); instantly on load.
        const track = this.track;
        if (track && !fromSwipe) {
          const left = index * track.clientWidth;
          if (Math.abs(track.scrollLeft - left) > 1) {
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            track.scrollTo({ left, behavior: first || reduce ? 'auto' : 'smooth' });
          }
        }

        // The chip for this Symbol, or (group mode) for its group: siblings share one chip.
        const chipFor = (i) => this.chips.find((c) => Number(c.dataset.index) === i);
        let activeChip = chipFor(index);
        if (!activeChip) {
          for (const sibling of panel.querySelectorAll('[data-sx-go]')) {
            activeChip = chipFor(Number(sibling.dataset.sxGo)) || activeChip;
          }
        }
        this.chips.forEach((c) => {
          const on = c === activeChip;
          c.setAttribute('aria-selected', String(on));
          c.tabIndex = on ? 0 : -1;
        });
        if (!activeChip) return;

        // Bring the chip into view inside the rail only: never scroll the page (scrollIntoView would
        // jump the page down to this section on load), and only take focus when using the keyboard.
        const rail = this.rail;
        if (rail && rail.scrollWidth > rail.clientWidth) {
          const chipBox = activeChip.getBoundingClientRect();
          const railBox = rail.getBoundingClientRect();
          let left = rail.scrollLeft;
          if (chipBox.left < railBox.left) left += chipBox.left - railBox.left - 16;
          else if (chipBox.right > railBox.right) left += chipBox.right - railBox.right + 16;
          if (left !== rail.scrollLeft) rail.scrollTo({ left, behavior: fromKeyboard || fromSwipe ? 'smooth' : 'auto' });
        }
        if (fromKeyboard) activeChip.focus({ preventScroll: true });
      }

      onKeydown = (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const current = this.chips.findIndex((c) => c.getAttribute('aria-selected') === 'true');
        const delta = event.key === 'ArrowRight' ? 1 : -1;
        const next = this.chips[(current + delta + this.chips.length) % this.chips.length];
        if (next) this.activate(Number(next.dataset.index), true);
      };

      onClick = (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        const chip = target.closest('.bl-sx__chip');
        if (chip) return this.activate(Number(chip.dataset.index), false);

        const sibling = target.closest('[data-sx-go]');
        if (sibling) return this.activate(Number(sibling.dataset.sxGo), false);

        const swap = target.closest('[data-sx-swap]');
        if (swap) return this.swap(swap);

        const select = target.closest('[data-sx-select]');
        if (select) this.select(select, event);
      };

      // Swap the main photo and the jewellery circle.
      swap(button) {
        const hero = button.closest('.bl-sx__media-item')?.querySelector('.bl-sx__hero');
        const inset = button.querySelector('img');
        if (!hero || !inset) return;
        const heroSrc = hero.currentSrc || hero.src;
        const insetSrc = inset.currentSrc || inset.src;
        hero.removeAttribute('srcset');
        inset.removeAttribute('srcset');
        hero.src = insetSrc.replace(/width=\d+/, 'width=1200');
        inset.src = heroSrc.replace(/width=\d+/, 'width=400');
        inset.classList.toggle('bl-sx__inset-piece');
      }

      // "Select <month>": pick that option in the page's variant picker (radio buttons or a dropdown).
      select(link, event) {
        const value = link.dataset.sxSelect;
        const picker =
          document.querySelector('variant-picker[data-template-product-match="true"]') ||
          document.querySelector('variant-picker');
        if (!picker) return;
        const radio = Array.from(picker.querySelectorAll('input[type="radio"]')).find((r) => r.value === value);
        const option = Array.from(picker.querySelectorAll('select option')).find((o) => o.value === value);
        if (radio) {
          if (!radio.checked) radio.click();
        } else if (option) {
          option.parentElement.value = value;
          option.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          return;
        }
        event.preventDefault();
        picker.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }

    customElements.define('bl-symbol-explorer', BlSymbolExplorer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl-wall-of-love"] && !Shopify.designMode) return;
  try {
    
  /** [BL] Wall of Love: on phones, "See more comments" shows the rest of the screenshots. */
  class BlWallOfLove extends HTMLElement {
    connectedCallback() {
      this.querySelector('.bl-wol__more')?.addEventListener('click', this.#expand);
    }

    disconnectedCallback() {
      this.querySelector('.bl-wol__more')?.removeEventListener('click', this.#expand);
    }

    #expand = (/** @type {Event} */ event) => {
      this.toggleAttribute('expanded', true);
      /** @type {HTMLElement} */ (event.currentTarget).setAttribute('aria-expanded', 'true');
    };
  }

  if (!customElements.get('bl-wall-of-love')) customElements.define('bl-wall-of-love', BlWallOfLove);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-charms-necklace"] && !Shopify.designMode) return;
  try {
    
  /**
   * [BL] "Your keepsake set" panel that follows the buy box's set builder (set panel → "Follow the
   * shopper's set"). bl-addon-tray announces its set on every render (`bl-tray:render`); the item rows and
   * the total are rebuilt from it, and the page's other set prices (hero, promise: `data-bl-set-now` /
   * `data-bl-set-was`) follow. Shipping and gift rows stay as rendered.
   */
  class BlSetSummary extends HTMLElement {
    connectedCallback() {
      document.addEventListener('bl-tray:render', this.update);
      const tray = /** @type {any} */ (document.querySelector('bl-addon-tray'));
      if (tray?.summary) this.update({ detail: tray.summary });
    }

    disconnectedCallback() {
      document.removeEventListener('bl-tray:render', this.update);
    }

    /** @param {any} event - `bl-tray:render`, or the tray's summary wrapped as `{ detail }` */
    update = ({ detail }) => {
      if (!detail?.product?.price || !detail.total) return;
      const list = this.querySelector('dl');
      const total = this.querySelector('[data-bl-set-total]');
      if (!list || !total) return;

      const rows = [
        { title: detail.product.title, price: detail.product.price, compareAt: detail.product.compareAt },
        ...detail.items.map((/** @type {any} */ item) => ({
          title: item.quantity > 1 ? `${item.title} × ${item.quantity}` : item.title,
          price: item.price,
          compareAt: item.compareAt,
        })),
      ];
      // The set's rows come first; shipping, gift box and the total stay where they are.
      const anchor = [...list.children].find((row) => !row.hasAttribute('data-bl-set-row')) || null;
      list.querySelectorAll('[data-bl-set-row]').forEach((row) => row.remove());
      for (const row of rows) list.insertBefore(this.#row(row), anchor);

      // The page's other set prices (hero, promise) follow too.
      document.querySelectorAll('[data-bl-set-now]').forEach((price) => (price.textContent = detail.total));
      document.querySelectorAll('[data-bl-set-was]').forEach((price) => {
        price.textContent = detail.wasTotal;
        price.hidden = !detail.saved;
      });

      total.replaceChildren(document.createTextNode(detail.total));
      if (detail.saved && this.dataset.savingLabel) {
        const saving = document.createElement('span');
        saving.className = 'lp-keepsake__saving';
        saving.textContent = `${this.dataset.savingLabel} ${detail.saved}`;
        total.append(saving);
      }
    };

    /** @param { { title: string, price: string, compareAt?: string } } row */
    #row({ title, price, compareAt }) {
      const row = document.createElement('div');
      row.className = 'lp-keepsake__row';
      row.dataset.blSetRow = '';
      const term = document.createElement('dt');
      term.textContent = title;
      const value = document.createElement('dd');
      if (compareAt) {
        const was = document.createElement('s');
        was.textContent = compareAt;
        value.append(was);
      }
      value.append(document.createTextNode(price || ''));
      row.append(term, value);
      return row;
    }
  }

  if (!customElements.get('bl-set-summary')) customElements.define('bl-set-summary', BlSetSummary);

  /**
   * [BL] A necklace sold alone (no charms, so no set builder and no `bl-tray:render`): the page's prices
   * (hero, set panel, promise) follow the buy box's option choice, e.g. Gold Vermeil ↔ Sterling Silver,
   * from the variants the section lists in `data-bl-necklace-variants`.
   */
  document.addEventListener('change', (event) => {
    const picker = event.target instanceof Element ? event.target.closest('variant-picker') : null;
    if (!picker?.closest('featured-product-information, product-information')) return;
    if (document.querySelector('bl-addon-tray')) return;
    const list = document.querySelector('script[data-bl-necklace-variants]');
    if (!list) return;

    const chosen = [
      ...picker.querySelectorAll('input[type="radio"]:checked'),
      ...picker.querySelectorAll('select'),
    ].map((field) => /** @type {HTMLInputElement | HTMLSelectElement} */ (field).value);
    /** @type {Array<{ options: string[], price: string, compareAt: string, saved: string }>} */
    const variants = JSON.parse(list.textContent || '[]');
    const variant = variants.find((entry) => entry.options.every((option) => chosen.includes(option)));
    if (!variant) return;

    document.querySelectorAll('[data-bl-set-now]').forEach((price) => (price.textContent = variant.price));
    document.querySelectorAll('[data-bl-set-was]').forEach((price) => {
      price.textContent = variant.compareAt;
      /** @type {HTMLElement} */ (price).hidden = !variant.compareAt;
    });
    document.querySelectorAll('[data-bl-necklace-price]').forEach((cell) => {
      const nodes = [];
      if (variant.compareAt) {
        const was = document.createElement('s');
        was.textContent = variant.compareAt;
        nodes.push(was);
      }
      nodes.push(document.createTextNode(variant.price));
      cell.replaceChildren(...nodes);
    });
    document.querySelectorAll('[data-bl-set-total]').forEach((total) => {
      total.replaceChildren(document.createTextNode(variant.price));
      const label = /** @type {HTMLElement} */ (total).dataset.savingLabel;
      if (variant.saved && label) {
        const saving = document.createElement('span');
        saving.className = 'lp-keepsake__saving';
        saving.textContent = `${label} ${variant.saved}`;
        total.append(saving);
      }
    });
  });

  /**
   * [BL] Engraving on the annotated photo's heart that swaps between its lines every 2 seconds
   * (annotated → "Swap the lines every 2 seconds").
   */
  class BlEngravingCycle extends HTMLElement {
    /** @type {number | undefined} */
    #timer;

    connectedCallback() {
      const frames = [...this.children];
      if (frames.length < 2) return;
      let index = 0;
      this.#timer = window.setInterval(() => {
        frames[index].classList.remove('is-active');
        index = (index + 1) % frames.length;
        frames[index].classList.add('is-active');
      }, 2000);
    }

    disconnectedCallback() {
      window.clearInterval(this.#timer);
    }
  }

  if (!customElements.get('bl-engraving-cycle')) customElements.define('bl-engraving-cycle', BlEngravingCycle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
